import { createFileRoute } from '@tanstack/react-router';

import { staticPageHead } from '@/config/seo-head';
import { WritingIndexPage } from '@/features/writing/components/writing-index-page';
import { loadPublishedWriting } from '@/features/writing/writing-loaders';

export const Route = createFileRoute('/blog/')({
  loader: () => loadPublishedWriting(),
  head: () => staticPageHead('/blog'),
  component: WritingIndexRoute,
});

function WritingIndexRoute() {
  const { posts, activeCategories } = Route.useLoaderData();
  return <WritingIndexPage posts={posts} activeCategories={activeCategories} />;
}
